import React from "react";
import ChrWidgetHeaderFooterTemplate from "./Template/ChrWidgetHeaderFooterTemplate";

const ChrWidgetHeader = (props) => {
  return (
    <ChrWidgetHeaderFooterTemplate
      headerClass="cui-widget-header"
      wrapperClass="border-bottom border-default"
      { ...props }
    />
  )
}

export default ChrWidgetHeader;
